// Libraries
import { Box, Flex } from '@chakra-ui/react';
// Components
import { TableFiltersRatings } from '../TableFiltersRatings';
// Types
import { FilterFactory, FilterGroupsType, FilterVariant, TableFiltersDisplayProps } from '@organisms/index';

/**
 * TableFiltersHidden component displays hidden filters for table columns.
 *
 * @component
 * @template TableBody - The type of the table body data.
 * @template ColumnNames - The type of the column names.
 * @param {TableFiltersDisplayProps<TableBody, ColumnNames>} props - The component props.
 * @param {ColumnsGroup<TableBody>} props.columnsGroup -  Object representing the columns of the table.
 * @param {FilterOptionsMap<ColumnNames>} props.filterOptionsMap - Map of filter options for each column.
 *
 * @returns {ReactElement} The TableFiltersHidden component.
 */
export const TableFiltersHidden = <TableBody, ColumnNames extends string>({
  filterOptionsMap,
  columnsGroup,
}: TableFiltersDisplayProps<TableBody, ColumnNames>) => {
  return (
    <Flex direction='column'>
      {Object.keys(columnsGroup).map((groupKey) => {
        if (groupKey === FilterGroupsType.CII_RATING) {
          return (
            <TableFiltersRatings
              key='cii_ratings_filter_container'
              ciiColumns={columnsGroup[groupKey]}
              filterOptionsMap={filterOptionsMap}
              variant={FilterVariant.HIDDEN}
            />
          );
        }
        return columnsGroup[groupKey].map((column) =>
          column.getCanFilter() ? (
            <Box key={`${column.id}_filter_container`} w='full'>
              <FilterFactory<TableBody, ColumnNames>
                key={`${column.id}_filter`}
                column={column}
                columnId={column.id}
                filterOptionsMap={filterOptionsMap}
                variant={FilterVariant.HIDDEN}
              />
            </Box>
          ) : null
        );
      })}
    </Flex>
  );
};
